<template>
  <footer class="footer">
    <div class="footer-content">
      <img src="@/assets/footlogger.png" alt="Logo" class="footer-image">
      <div class="footer-logo">
        Copyright ©2026 新知数字，保留所有权利。
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
          皖ICP备16011495号-5
        </a>
      </div>
      <div class="footer-copyright">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?recordcode=34010402701990" target="_blank" rel="noopener noreferrer" class="beian-link">
          皖公网安备 34010402701990号
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  background: #000;
  color: #fff;
  min-height: 35vh;
  margin-top: auto;
  position: relative;
}

.footer-content {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.footer-image {
  height: 23vh;
  max-height: 200px;
  opacity: 1;
  object-fit: contain;
}

.footer-logo, .footer-copyright {
  font-size: 1rem;
  opacity: 0.6;
  text-align: center;
  line-height: 1.5;
}

/* 备案号链接样式 */
.beian-link {
  color: inherit;
  text-decoration: none;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  word-break: keep-all;
}

.beian-link:hover {
  opacity: 1;
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer {
    min-height: 25vh;
  }
  
  .footer-content {
    padding: 0 1rem;
    gap: 0.8rem;
  }
  
  .footer-image {
    height: 12vh;
    max-height: 120px;
  }
  
  .footer-logo, .footer-copyright {
    font-size: 0.8rem;
    padding: 0 0.5rem;
  }
  
  /* 确保备案号在移动端不换行 */
  .beian-link {
    display: inline-block;
    margin: 0.2rem 0;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .footer {
    min-height: 20vh;
  }
  
  .footer-content {
    gap: 0.6rem;
  }
  
  .footer-image {
    height: 10vh;
    max-height: 100px;
  }
  
  .footer-logo, .footer-copyright {
    font-size: 0.7rem;
    line-height: 1.4;
  }
}
</style>